import { render, staticRenderFns } from "./BSearchField.vue?vue&type=template&id=0f24bea6"
import script from "./BSearchField.vue?vue&type=script&lang=js"
export * from "./BSearchField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports